<div class="d-inline-flex align-items-center py-3 bg-light p-3 rounded-4">
  <div class="d-flex flex-column">
    <span class="text-muted fs-14">{{ productCode() }}</span>
    <h3 class="mb-0 fw-bold">{{ productName() }}</h3>
  </div>
  <button class="ms-3 btn btn-primary btn-h42 d-flex align-items-center gap-2" (click)="setupProductClick.emit()">
    Setup Product <i class="bi bi-chevron-down"></i>
  </button>
</div>
